import { FC, useEffect, useRef } from "react";
import barcodeScanner from "./barcodeScanner";

export type BarcodeScannerRef = {
  onTurnOffCamera: () => void;
};

interface BarcodeScannerProps {
  submitValue: (value: string) => void;
  active: boolean;
}

export const BarcodeScannerView: FC<BarcodeScannerProps> = (props) => {
  const { submitValue, active } = props;
  const scannerViewRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scannerViewRef.current) return;
    barcodeScanner.turnOn(scannerViewRef.current);
  }, [submitValue]);

  useEffect(() => {
    barcodeScanner.on("onScan", submitValue);
    return () => {
      barcodeScanner.off("onScan", submitValue);
    };
  }, [submitValue]);

  useEffect(() => {
    if (!scannerViewRef.current) return;
    if (active) {
      barcodeScanner.turnOn(scannerViewRef.current);
    } else {
      barcodeScanner.standby();
    }
  }, [active]);

  return (
    <div className="wrapper">
      <div className="top">
        <div
          style={{
            display: "grid",
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            id="data-capture-view"
            ref={scannerViewRef}
            style={{
              position: "relative",
              height: "100%",
              width: "100%",
            }}
          />
        </div>
      </div>
    </div>
  );
};
